import type { ComponentType } from 'react';
import {
  getPostMeta,
  slugFromPath,
  type BlogPostMeta,
  type MDXComponents,
} from './meta';

export interface BlogPost extends BlogPostMeta {
  Component: ComponentType<{ components?: MDXComponents }>;
}

// The compiled article bodies, and nothing else. Importing this module pulls
// every published post into the importing chunk, so only a page COMPONENT may
// import it - a route `loader` or `head` must use `./meta` instead. See the
// comment on the frontmatter glob there for what that separation buys.
const components = import.meta.glob<ComponentType<{ components?: MDXComponents }>>(
  '/content/blog/*.mdx',
  { eager: true, import: 'default' },
);

const BY_SLUG = new Map(
  Object.entries(components).map(([path, Component]) => [slugFromPath(path), Component]),
);

/** A published post with its compiled body, or undefined for a draft/unknown slug. */
export function getPost(slug: string): BlogPost | undefined {
  const meta = getPostMeta(slug);
  const Component = BY_SLUG.get(slug);
  if (!meta || !Component) return undefined;
  return { ...meta, Component };
}
